import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store";
import { handleChange } from "../../store/coupons/couponReducer";
import { FETCH_COUPON_DATA } from "../../store/coupons/constants";
import styles from "./index.module.css";
import InputField from "./InputField";
import Button from "./Button";

const SearchAdd = () => {

    const dispatch = useDispatch();
    const couponState = useSelector((state: RootState) => state.couponState);
    const { searchText, skip, limit } = couponState;
    const [isSearchTextBackspacedToEmpty, setIsSearchTextBackspacedToEmpty] = useState(false);
    

    useEffect(() => {

        if(!isSearchTextBackspacedToEmpty && !searchText) return; 
      
        // Calling setTimeout directly will make api call for each character typed. But assigning
        // this function to a variable re-initializes the timer. So, just one api call will be made
        // when user stops typing.
        const delayAPICall = setTimeout(() => {

            dispatch({ 
                type: FETCH_COUPON_DATA,
                payload: { 
                    searchText, 
                    skip, 
                    limit,
                    fetchTreatmentData: false 
                } 
            })

        }, 500);

        if(isSearchTextBackspacedToEmpty) setIsSearchTextBackspacedToEmpty(false);

        return () => clearTimeout(delayAPICall);

    }, [searchText])


    const searchCoupons = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        dispatch(handleChange({
            name: "searchText",
            value
        }))
        if(!value) setIsSearchTextBackspacedToEmpty(true);
    }

    const openModal = () => {
        dispatch(handleChange({
            name: "isAdding",
            value: true
        }));
    } 

    return (
        <div className = {styles.search_add_btn}>
            <InputField
                customClassName="search_input" 
                type = "text"
                name = "search"
                value = {searchText}
                placeholder="Search"
                handleChange={searchCoupons}
            />
            <Button
                customClassName="add_btn"
                buttonText="Add New Coupon"
                handleClick = {openModal}
            />
        </div>
    );

}

export default SearchAdd;